import { createDebugLogger } from '@fantasticfour/shared';

export { compact } from '@fantasticfour/shared';
export const debug = createDebugLogger('firestore-world');
